import {User} from 'src/app/shared/models/user.model';

export enum DType {
  CARD = 'card',
  IBAN = 'iban'
}

export class DepositRial {
  id: number;
  user: User;
  callbackStatus: string;
  callbackTrackingCode: string;
  callbackMessage: string;
  amount: number;
  createdAt: string;
  receivedAt: string;
  provider: string;
  userCreditCard: string;
  userIban!: string;

  constructor(input: any = {}) {
    this.id = input.id;
    this.user = new User(input.user);
    this.callbackStatus = input.callback_status;
    this.provider = input.provider;
    this.callbackTrackingCode = input.callback_tracking_code;
    this.callbackMessage = input.callback_message;
    this.userCreditCard = input.user_credit_card;
    this.userIban = input.user_iban;
    this.amount = Math.round(input.amount / 10);
    this.createdAt = input.created_at;
    this.receivedAt = input.received_at;
  }
}
